module.exports = __webpack_public_path__ + "img/ventas.230fc4b1.png";